import { render, staticRenderFns } from "./liveClassDetailsList.vue?vue&type=template&id=82a61978&scoped=true"
import script from "./liveClassDetailsList.vue?vue&type=script&lang=js"
export * from "./liveClassDetailsList.vue?vue&type=script&lang=js"
import style0 from "./liveClassDetailsList.vue?vue&type=style&index=0&id=82a61978&prod&lang=less&scoped=true"
import style1 from "./liveClassDetailsList.vue?vue&type=style&index=1&id=82a61978&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82a61978",
  null
  
)

export default component.exports